module.exports = __webpack_public_path__ + "img/brandgigwi.d3a7e1ae.jpg";